import React from "react";
import { Button } from "../ui/button";

/**
 * Bloque de descarga de Nivel 2 (Kit Documental).
 */
export function N2DownloadBlock({ n2Doc, caseDoc, acting, onDownload }) {
  return (
    <div
      className={`border p-6 ${caseDoc?.variant_nivel2 === "auto" ? "border-amber-300 bg-amber-50/40" : "border-indigo-200 bg-indigo-50/40"}`}
      data-testid="n2-download-block"
    >
      <p
        className={`text-[11px] uppercase tracking-widest font-medium mb-2 ${caseDoc?.variant_nivel2 === "auto" ? "text-amber-800" : "text-indigo-800"}`}
      >
        Kit Documental disponible {caseDoc?.variant_nivel2 === "auto" ? "(Sin revisión humana)" : ""}
      </p>
      <h3 className="font-serif text-xl text-gray-900 mb-2">
        {caseDoc?.variant_nivel2 === "auto"
          ? "Tu paquete fue generado automáticamente y está disponible"
          : "Tu paquete está aprobado para descarga"}
      </h3>
      <p className="text-sm text-gray-700 mb-4">
        {caseDoc?.variant_nivel2 === "auto" ? (
          <>
            Este Kit Documental fue generado por IA <strong>sin revisión humana experta</strong>.
            Los documentos son insumos de apoyo y no reemplazan el concepto de un abogado titulado
            ni la decisión del ordenador del gasto.
            <span className="block mt-2 text-amber-900">
              La responsabilidad por el uso del contenido es exclusivamente del usuario.
            </span>
          </>
        ) : (
          <>
            La revisión humana fue completada por nuestro experto. Descarga el ZIP con los
            documentos del Kit Documental Nivel 2. Cada descarga queda registrada con hash SHA-256.
          </>
        )}
        {n2Doc.fallbacks_used?.length > 0 && (
          <span className="block mt-2 text-amber-700">
            Algunas secciones se entregaron en HTML/CSV de respaldo en lugar de DOCX/XLSX:{" "}
            {n2Doc.fallbacks_used.join(", ")}.
          </span>
        )}
      </p>
      <div className="flex flex-wrap gap-3 items-center">
        <Button
          onClick={onDownload}
          disabled={acting}
          className="rounded-sm h-11"
          data-testid="case-download-n2-button"
        >
          {acting ? "Descargando…" : "Descargar Kit Documental (ZIP)"}
        </Button>
        <span
          className="text-xs text-gray-500 font-mono truncate max-w-[280px]"
          title={n2Doc.hash_sha256}
        >
          SHA-256 {n2Doc.hash_sha256?.slice(0, 16)}…
        </span>
      </div>
    </div>
  );
}
